import gql from 'graphql-tag'

export const TEMPLATE = gql`
  query emailTemplate($entity: Entity!, $entityId: Int!) {
    emailTemplate(entity: $entity, entityId: $entityId) {
      subject
      organizer { name emails }
      participant { name emails }
    }
  }
`

export const SEND_EMAIL = gql`
  mutation sendEmail($entity: Entity!, $entityId: Int!, $emailInput: EmailInput!) {
    sendEmail(entity: $entity, entityId: $entityId, emailInput: $emailInput) {
      msg
    }
  }
`
